import React from "react";
import { FiSettings } from "react-icons/fi";
import { AiOutlinePlus } from "react-icons/ai";
import { Link } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import { BiChevronLeft } from "react-icons/bi";
import CountryTable from "../countryTable/CountryTable";
import { Pagination } from "antd";

function ListCountries({ data, getCountryData, onChangeVal, initialVlue, handleChange, reset }) {
  return (
    <>
      <div className="pageTableWrapper">
        <div className="pageHeader">
          <div className="pageTitle">
            <FiSettings />
            <h5>COUNTRIES</h5>
          </div>
          <div className="addNew">
            <Link to="/admin/create-country" className="btn btn-success">
              <AiOutlinePlus /> Add New Country
            </Link>
          </div>
        </div>

        <div className="pageBody">
          <CountryTable data={data} getCountryData={getCountryData} initialVlue={initialVlue} handleChange={handleChange} reset={reset} />
        </div>

        <div className="pageFooter">
          <div className="row">
            <div className="col-md-6">
              <div className="showEntry">
                <p>Showing {data?.totalCountries} entries</p>
              </div>
            </div>
            <div className="col-md-6">
              <Pagination
                defaultCurrent={1}
                onChange={onChangeVal}
                total={data?.totalCountries}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ListCountries;
